import React from "react";

const InputField = ({ type, name, value, handleChange, labelText, customClasses }) => {
    return (
        <div>
            <label
                htmlFor={name}
                className='mb-2 block text-sm font-medium text-gray-900 dark:text-gray-300'
            >
                {labelText || name}
            </label>
            <input
                type={type}
                value={value}
                name={name}
                onChange={handleChange}
                className='block w-full max-w-[22rem] rounded-md  border-2 bg-main-800 p-2.5 text-sm'
                placeholder={name}
            />
        </div>
    );
};

export default InputField;
